let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9WOuk")).then(() => parcelRequire('1GZ9O'));